import React, { PropsWithChildren } from 'react';
import { Control } from 'react-hook-form';

import InlineInput from '@/components/InlineInput';
import { FormField } from '@/components/ui/form';

import { ICompanyFormSchema } from './schema';
import MaskedInput from '@/components/MaskedInput';

interface IProps extends PropsWithChildren {
  control: Control<ICompanyFormSchema>;
  isLoading: boolean;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
}

const CompanyFormStepView: React.FC<IProps> = ({
  control,
  isLoading,
  onSubmit,
  children,
}) => (
  <form onSubmit={onSubmit}>
    <div className="grid gap-4 py-4">
      <FormField
        control={control}
        name="tradingName"
        render={({ field }) => (
          <InlineInput
            title="Nome da empresa"
            disabled={isLoading}
            {...field}
          />
        )}
      />
      <FormField
        control={control}
        name="registrationNumber"
        render={({ field }) => (
          <InlineInput
            title="CNPJ"
            disabled={isLoading}
            as={MaskedInput}
            maskOptions={{
              mask: '00.000.000/0000-00',
            }}
            {...field}
          />
        )}
      />
      <FormField
        control={control}
        name="companyName"
        render={({ field }) => (
          <InlineInput title="Razão Social" disabled={isLoading} {...field} />
        )}
      />
    </div>
    {children}
  </form>
);

export default CompanyFormStepView;
